/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      const llQuoterTool = document.querySelector( '.ll-quoter-tool' );
      const headerVisibility = document.querySelector( '.header-visibility' );
      const footerVisibility = document.querySelector( '.footer-visibility' );
      // console.log( llQuoterTool );
      if ( llQuoterTool ) {
        $( headerVisibility ).toggleClass( 'hidden' );
        $( footerVisibility ).toggleClass( 'hidden' );
        $( 'body' ).css( 'padding-top', 0 );
      } else {
        $( headerVisibility ).removeClass( 'hidden' );
        $( footerVisibility ).removeClass( 'hidden' );
      }

      if ( $( 'body' ).hasClass( 'page-template-template-quoter' ) ) {
        toggleNextButton();

        $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
          toggleNextButton();
        } );
      }

      function toggleNextButton() {
        if ( $( '.llgq-current-page' ).hasClass( 'next-page' ) ) {
          $( '.gform_page_footer' ).find( '.gform_next_button' ).addClass( 'sr-only' );
          $( '.next_button' ).removeClass( 'hidden' );
          $( '.next_button' ).addClass( 'block' );
        } else {
          $( '.gform_page_footer' ).find( '.gform_next_button' ).removeClass( 'sr-only' );
          $( '.next_button' ).removeClass( 'block' );
          $( '.next_button' ).addClass( 'hidden' );
        }
      }

      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).slideToggle();
      } );

      $( '.faq-toggle' ).on( 'toggleAfter', ( event ) => {
        $( $( event.target ).attr( 'data-toggle-target' ) ).slideToggle();
      } );

      $( '.dropdown-toggle' ).on( 'toggleAfter', ( event ) => {
        $( $( event.target ).attr( 'data-menu' ) ).slideToggle( '500', 'swing' );
      } );

      $( '.child-toggle' ).on( 'toggleAfter', ( event ) => {
        $( $( event.target ).attr( 'data-toggle-target' ) ).slideToggle();
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      if ( $( '.gform_wrapper' ).length > 0 && typeof( gform ) !== 'undefined' ) {
        gform.addAction( 'gform_input_change', function( elem, formId, fieldId ) {
          if ( $( '#input_' + formId + '_' + fieldId ).val() ) {
            const path = $( '#input_' + formId + '_' + fieldId ).val().replace( 'C:\\fakepath\\', '' );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).find( '.file-upload-label' ).text( path );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).addClass( 'has-file' );
          } else {
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).find( '.file-upload-label' ).text( 'No file selected' );
            $( '#input_' + formId + '_' + fieldId ).closest( '.ginput_container_fileupload' ).removeClass( 'has-file' );
          }
        }, 10, 3 );

        $( document ).on( 'change', '.llgq-current-page input[type="radio"]', function() {
          if ( $( '.llgq-current-page' ).find( '.llgq_section_wrapper_2 .gfield' ).length == 1 ) {
            $( '.llgq-current-page .gform_next_button' ).trigger( 'click' );
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
